import { mapActions, mapMutations, mapGetters } from "vuex";

import {
  resetUserPassword,
  RegisterCustomer,
  updateUser,
  signInWithPassword
} from "./../../../src/api/services/userService";
export default {
  methods: {
    ...mapActions([
      "signUserIn",
      "signUserUp",
      "signUserInFacebook",
      "signUserInGoogle",
      "logout"
    ]),
    ...mapMutations(["setStoreLoaded", "setUser", "setStore"]),
    ...mapGetters(["user"]),
    goBack() {
      this.$router.push({
        name: "store",
        params: { storeid: this.storeid }
      });
    },
    signOut() {
      this.logout();
      this.goBack();
    },
    loadRecoveryPasswordForm(base64User) {
      let that = this;
      const decodedUserDocFromUrl = JSON.parse(
        new Buffer(base64User, "base64").toString("ascii")
      );

      signInWithPassword(
        decodedUserDocFromUrl.Email,
        decodedUserDocFromUrl.ResetPasswordToken
      )
        .then(() => {
          that.UserDoc = decodedUserDocFromUrl;
          that.IsNewUser = that.UserDoc.IsNewUser;
          that.setStoreLoaded();
          that.setStore(that.storeid);
        })
        .catch(() => {
          that.recoveryLinkExpired = true;
          window.setTimeout(function() {
            that.signOut();
          }, 4000);
        });
    },
    async resetUserPassword() {
      let that = this;
      if (that.loading) return;
      this.$validator.validateAll().then(async valid => {
        if (!valid) return;
        that.loading = true;
        that.UserDoc.Company_ID = this.storeid;
        resetUserPassword(that.UserDoc).then(() => {
          that.registrationResponse = {
            status: 200,
            msg: "Registration completed successfully."
          };
          that.loading = false;
          window.setTimeout(function() {
            that
              .signUserIn({
                email: that.UserDoc.Email,
                password: that.UserDoc.Password
              })
              .then(() => {
                if (!that.storeid) that.$router.push("/");
                else {
                  that.$router.push(`../../../../store/${that.storeid}`);
                }
              });
          }, 2000);
        });
      });
    },

    register() {
      this.$validator.validateAll().then(valid => {
        if (!valid) return;
        this.loading = true;
        let that = this;
        this.signUserUp({ email: this.email, password: this.password })
          .then(() => {
            let newUser = that.user();
            RegisterCustomer(newUser.id, {
              Email: that.email,
              FirstName: that.firstName,
              LastName: that.lastName
            })
              .then(() => {
                updateUser(newUser.id, {
                  FirstName: that.firstName,
                  LastName: that.lastName,
                  DisplayName: that.firstName + " " + that.lastName,
                  FirebaseUDID: newUser.id,
                  Email: that.email
                })
                  .then(() => {
                    that.loading = false;
                    if (!that.isMobile()) that.$emit("close-overlay");
                    else {
                      if (!that.storeid) that.$router.push("/");
                      else {
                        if (that.forgift && that.forgift === true)
                          that.$router.push(
                            `../../store/${that.storeid}/checkout/giftcards`
                          );
                        else
                          that.$router.push(
                            `../../store/${that.storeid}/checkout`
                          );
                      }
                    }
                  })
                  .catch(() => {
                    that.loading = false;
                    that.$emit("close-overlay");
                  });
              })
              .catch(error => {
                that.loading = false;
                that.error = error.message;
              });
          })
          .catch(error => {
            that.loading = false;
            that.error = error.message;
          });
      });
    },
    facebookLogin() {
      let that = this;
      this.signUserInFacebook()
        .then(() => {
          if (!that.isMobile()) that.$emit("close-overlay");
          else {
            if (!that.storeid) that.$router.push("/");
            else {
              if (that.forgift && that.forgift === true)
                that.$router.push(
                  `../../store/${that.storeid}/checkout/giftcards`
                );
              else that.$router.push(`../../store/${that.storeid}/checkout`);
            }
          }
        })
        .catch(error => {
          that.error = error.message;
        });
    },
    googleLogin() {
      let that = this;
      this.signUserInGoogle()
        .then(() => {
          if (!that.isMobile()) that.$emit("close-overlay");
          else {
            if (!that.storeid) that.$router.push("/");
            else {
              if (that.forgift && that.forgift === true)
                that.$router.push(
                  `../../store/${that.storeid}/checkout/giftcards`
                );
              else that.$router.push(`../../store/${that.storeid}/checkout`);
            }
          }
        })
        .catch(error => {
          that.error = error.message;
        });
    }
  }
};
